module.exports = __webpack_public_path__ + "img/8.04b47561.jpg";